import React, { useEffect, useState } from 'react';
import { ShieldCheckIcon } from '@heroicons/react/outline';
import API from '../utils/api';

const MODE_LABELS = {
    enabled: 'Passwords allowed for everyone',
    unlinked_only: 'Passwords only for users who haven’t linked Google/Apple',
    disabled: 'Password sign-in retired',
};

// Admin view of the password → Google/Apple migration.
const SsoAdoptionCard = () => {
    const [status, setStatus] = useState(null);
    const [showAll, setShowAll] = useState(false);

    useEffect(() => {
        let cancelled = false;
        API.getData('auth/sso-status').then((data) => {
            if (!cancelled && data && typeof data.totalUsers === 'number') setStatus(data);
        });
        return () => { cancelled = true; };
    }, []);

    if (!status) return null;

    const percent = status.totalUsers ? Math.round((status.linkedUsers / status.totalUsers) * 100) : 0;
    const remaining = status.passwordOnlyUsers;
    const visible = showAll ? remaining : remaining.slice(0, 5);

    return (
        <div className="overflow-hidden rounded-2xl border border-gray-200 bg-white shadow-sm">
            <div className="flex items-center justify-between border-b border-gray-200 px-5 py-4 sm:px-6">
                <div className="flex items-center gap-3">
                    <div className="rounded-full bg-emerald-500 p-2">
                        <ShieldCheckIcon className="h-5 w-5 text-white" />
                    </div>
                    <h2 className="text-lg font-semibold text-gray-900">Google & Apple sign-in</h2>
                </div>
                <span className="rounded-full bg-gray-100 px-3 py-1 text-xs text-gray-600">
                    {MODE_LABELS[status.passwordLoginMode] || status.passwordLoginMode}
                </span>
            </div>
            <div className="space-y-4 p-5 sm:p-6">
                <div>
                    <div className="flex items-baseline justify-between">
                        <p className="text-3xl font-bold text-gray-900">{percent}%</p>
                        <p className="text-sm text-gray-500">
                            {status.linkedUsers} of {status.totalUsers} users linked
                            {' '}(Google {status.byProvider.google} · Apple {status.byProvider.apple})
                        </p>
                    </div>
                    <div className="mt-2 h-2 rounded-full bg-gray-100" role="progressbar" aria-valuenow={percent} aria-valuemin={0} aria-valuemax={100}>
                        <div className="h-2 rounded-full bg-emerald-500" style={{ width: `${percent}%` }} />
                    </div>
                </div>
                {remaining.length > 0 ? (
                    <div>
                        <p className="mb-2 text-sm font-medium text-gray-700">Still using a password ({remaining.length})</p>
                        <ul className="divide-y divide-gray-100 text-sm">
                            {visible.map((u) => (
                                <li key={u.id} className="flex justify-between gap-4 py-2">
                                    <span className="font-medium text-gray-900">{u.name}</span>
                                    <span className="truncate text-gray-500">{u.email}</span>
                                </li>
                            ))}
                        </ul>
                        {remaining.length > 5 && (
                            <button type="button" onClick={() => setShowAll((v) => !v)} className="mt-2 text-sm font-medium text-emerald-700 hover:text-emerald-900">
                                {showAll ? 'Show fewer' : `Show all ${remaining.length}`}
                            </button>
                        )}
                    </div>
                ) : (
                    <p className="text-sm text-emerald-700">Everyone has linked Google or Apple.</p>
                )}
            </div>
        </div>
    );
};

export default SsoAdoptionCard;
